<a class="alc-icon-and-name back-to-link" (click)="disableCustomization()" *ngIf="canCustomize && customization">
  <mat-icon>chevron_left</mat-icon>
  <span translate="back"></span>
</a>

<iframe #inmessageIframe width="100%" height="100%" style="border: 0; margin: 0; padding: 0"> </iframe>

<button
  *ngIf="canCustomize && !customization"
  [ngClass]="chatPosition"
  mat-button
  color="primary"
  class="customize-in-message"
  (click)="enableCustomization()">
  <mat-icon>settings</mat-icon>&nbsp;
  <span>Customize</span>
</button>
